import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  Label,
  FormGroup,
  Input,
} from "reactstrap";
import { FileText } from "react-feather";
import { useDropzone } from "react-dropzone";
import { uploadBlob } from "services/blob";

const Publicar = (props) => {
  // ** Const

  const { open, setOpen, card } = props;
  const [fileName, setFileName] = useState("");
  const [fileExtension, setFileExtension] = useState("");
  const [file, setFile] = useState();
  const [godash, setGodash] = useState(false);
  const [idGodash, setIdGodash] = useState("");


  const getFileExtesion = (file) => {
    return file.name.split(".").pop();
  };

  const getFileName = (file) => {
    return file.name;
  };

  const getType = (extension) => {
    if (
      ["JPEG", "JPG", "PNG", "GIF","jpeg", "jpg", "png", "gif"].some(
        (ext) => ext.toLowerCase() === extension.toLowerCase()
      ) 
    ){
      return "img";
    }
    if (extension === "html") return "html";
    return "download";
  };

  const { getRootProps, getInputProps } = useDropzone({
    //accept: ".pbix, .pdf",
    onDrop: (acceptedFiles) => {
      if (acceptedFiles.length) {
        let filename = getFileName(acceptedFiles[0]);
        setFile(acceptedFiles[0]);
        setFileExtension(getFileExtesion(acceptedFiles[0]));
        setFileName(filename);
      } else {
        //toast.error("Select only files with a .pbix or .pdf extension!");
      }
    },
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    let url = `https://portal.godash.cloud/dashboard?dashboardId=${idGodash}&godash=true&token=`;
    let type = "html";
    if (!godash) {
      let area = localStorage.getItem("area");
      //let menu = localStorage.getItem("menu_completo");
      let menuId = localStorage.getItem("idMenu")
      type = getType(fileExtension);
      url = await uploadBlob(
        file,
        area,
        menuId,
        card.idCard?.toString(),
        card.idAba?.toString(),
        type,
        fileExtension
      );
    }
    let model = {
      params: {
        arg1: card.idAba,
        arg2: url,
        arg3: type,
        arg4: file?.name
      },
    };
    props.publishTab(model);
    setOpen(false);
  };

  return (
    <Modal
      isOpen={open}
      toggle={() => setOpen(!open)}
      className={`modal-dialog-centered`}
      size="lg"
    >
      <ModalHeader toggle={() => setOpen(!open)}>
        Publicar na aba {card?.abaTitulo}
      </ModalHeader>
      <ModalBody>
        <Form id="form" className="mb-2">
          <FormGroup className="ml-4 mt-3">
            <Label>
              <Input
                type="checkbox"
                checked={godash}
                onChange={(e) => setGodash(!godash)}
              />
              Relatório GoDash
            </Label>
          </FormGroup>
          {godash ? (
            <FormGroup>
              <Label for="nome">Id Relatório GoDash</Label>
              <Input
                type="text"
                id="name"
                placeholder="257"
                value={idGodash}
                name="menu"
                onChange={(e) => setIdGodash(e.target.value)}
              />
            </FormGroup>
          ) : (
            <FormGroup>
              <Label for="file">Arquivo</Label>
              <div
                style={{ border: "2px dashed #00a1f1", background: "#f8f8f8" }}
                {...getRootProps({
                  className: `dropzone py-4 flex-column`,
                })}
              >
                <input {...getInputProps()} />
                {fileName ? (
                  <div className="text-center">
                    <span>
                      {" "}
                      <FileText size={15} /> &nbsp;{fileName}
                    </span>
                  </div>
                ) : (
                  <div className="text-center">
                    <i className="nc-icon nc-cloud-download-93" />
                    <div className="mb-0 mt-1 mx-2 import-file">
                      Arraste o arquivo ou clique aqui
                    </div>
                  </div>
                )}
              </div>
            </FormGroup>
          )}
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button type="submit" onClick={(e) => handleSubmit(e)} color="primary">
          Publicar
        </Button>
      </ModalFooter>
    </Modal>
  );
};
export default Publicar;
